import {QuotePDFBuilder} from "./QuotePDFBuilder";
import {Div10TypeToName, TDiv10Type} from "../../../shopdrawing/div10/Div10Tabs";
import {PriceLine, PriceRider} from "../../../../../api/Pricing";
import {PriceSectionNote} from "../../../../../api/PriceSectionNotes";
import {QuotePriceLine, QuotePriceRider} from "../../../../../api/QuotePricing";

export function addDiv10Section(bld: QuotePDFBuilder, props: {
    riders: (QuotePriceRider | PriceRider)[];
    prices: (PriceLine | QuotePriceLine)[];
    notes: PriceSectionNote[]
    div10Key: TDiv10Type
}) {
    const k = props.div10Key;
    const isOurRider = (r) => {
        if(r.productType === "div-10" && r.sectionKey === "div-10/" + k) return true; // backwards compatible
        if(r.productType === "div-10" && r.sectionKey === "div-10/" + k + "-riders") return true
        return false
    }

    const riders = props.riders.filter(isOurRider);

    bld.addSection(
        {
            title: "Div 10: " + Div10TypeToName(k),
            note: props.notes.filter(n => n.keyName === "div10/" + k).map(v => v.note),
            div10SubCategory: Div10TypeToName(k),
            categories: [
                {
                    name: Div10TypeToName(k),
                    filter: (i: PriceLine | QuotePriceLine) => {
                        if(k === "wr-accessory") return i.productType === "div-10" && !i.div10;
                        return i.productType === "div-10" && i.div10?.category === k
                    },
                    filterRider: isOurRider,
                    adminExcludeRiders: true,
                }, !bld.excludeRiders && {
                    name: Div10TypeToName(k) + " Riders",
                    filter: () => false,
                    filterRider: isOurRider,
                }
            ],
        },
        (props.prices as PriceLine[]).filter(i => {
            if(k === "wr-accessory") return i.productType === "div-10" && !i.div10;
            return i.productType === "div-10" && i.div10?.category === k
        }),
        riders,
    )
}